import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import LabelledComponent from "components/BudgetBuilder/Setup/LabelledComponent";
import UnitSearchInput from "components/UnitSearchInput";
import { useDictionary } from "hooks";
import { fetchPicklistOptions, fetchSingleUnit } from "store/actions/picklists";
import { picklistsSelectors } from "store/selectors";


const UnitFinder = ({ label, placeholder, editable, unit, onChange, ...props }) => {
	const { options: units } = useSelector(picklistsSelectors.units);

	const dictionary = useDictionary("budgetBuilder.components.UnitFinder");

	useEffect(() => {
		fetchPicklistOptions("units");
	}, []);

	const unitText = useMemo(
		() => units.find(u => u.value === unit)?.text,
		[ unit, units ]
	);

	useEffect(() => {
		if (isNonEmptyString(unit) && !units.find(u => u.value === unit)) {
			fetchSingleUnit(unit);
		}
	}, [ unit, units ]);

	return (
		<LabelledComponent label={label ?? dictionary?.label}>
			{editable
				? (
					<UnitSearchInput
						{...props}
						selection
						placeholder={placeholder ?? dictionary?.label}
						onChange={unit => onChange(unit)}
						value={unit}
					/>
				)
				: unitText
			}
		</LabelledComponent>
	);
};

export default UnitFinder;
